export default __webpack_public_path__ + "Inter-Roman.var.woff2";